var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"q-glossary__letters-list-wrapper"},[_c('div',{ref:"letters",staticClass:"q-glossary__letters-list"},_vm._l((_vm.visibleLetters),function(letter,index){return _c('div',{key:index,staticClass:"q-glossary__letter",class:{
                'q-glossary__letter--disabled': !_vm.letters.includes(letter)
            },on:{"click":function($event){return _vm.goToLetter(letter)}}},[_vm._v(" "+_vm._s(letter)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }